import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
// import {CryptComponent} from './crypt/crypt.component';
import {AuthService} from './services/auth.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthCallbackComponent} from './auth-callback/auth-callback/auth-callback.component';
import {AuthInterceptor} from './auth.interceptor';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FabHeaderModule} from '@fabric/components/header';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {FabLoadingSpinnerModule} from '@fabric/components/loading-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {FabThemeSettingModule} from '@fabric/components/header-actions';
import {UnauthorizedPageComponent} from './unauthorized-page/unauthorized-page.component';
import {CryptMultipleComponent} from './crypt-multiple/crypt-multiple.component';
import {MatListModule} from '@angular/material/list';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatExpansionModule} from '@angular/material/expansion';

@NgModule({
  declarations: [
    AppComponent,
    // CryptComponent,
    AuthCallbackComponent,
    UnauthorizedPageComponent,
    CryptMultipleComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    FabHeaderModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    FabLoadingSpinnerModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    FabThemeSettingModule,
    MatListModule,
    MatTooltipModule,
    MatExpansionModule
  ],
  providers: [AuthService,
    {provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true},
    provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent]
})
export class AppModule {
}
